@if (dashboard.actionItems().length > 0) {
  <ct-lib-dashboard-card
    [title]="'jobboard.platform.dashboard.action-items.title' | transloco"
    [icon]="icons.clipboardList"
    [scrollable]="true"
  >
    <span dashboardCardHeaderActions class="count text-muted">
      {{ dashboard.actionItems().length }}
    </span>

    <div class="task-list" role="list">
      @for (actionItem of dashboard.actionItems(); track actionItem.id) {
        <app-platform-dashboard-task-item
          role="listitem"
          [actionItem]="actionItem"
          (complete)="openChoice.emit($event)"
        ></app-platform-dashboard-task-item>
      }
    </div>
  </ct-lib-dashboard-card>
}
